module.exports = __webpack_public_path__ + "static/media/restaurant_table.5b4c4397.svg";